
<template>
    

      <!-- Content -->
      <div class="admin-content">

                <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
  <!-- Left -->
  <div>
    <h5 class="mb-0 fw-semibold text-color">Client Management</h5>
    <p class="mb-0 text-muted small">
      Manage Customers and their Events
    </p>
  </div>
  <!-- Right -->
</div>

    <div class="row">

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-danger">Fetched Customers</p>
              <p class="card-big-p text-color">
                  <PriceFormat :Price="og_customers.length"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-green">Joined Last 7D</p>
              <p class="card-big-p text-color">
                <PriceFormat :Price=" dataz.cust_7day"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-orange">Joined Last 30D</p>
              <p class="card-big-p text-color">
               <PriceFormat :Price="dataz.cust_30day"/>
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-primary">Total Customer's</p>
              <p class="card-big-p text-color"> 
                  <PriceFormat :Price="dataz.cust_life"/>
              </p>
            </div>
          </div>


        </div>
      </div>

    </div>


<div class="card recent-orders-card mt-3 mb-5">
   <div class="card-header d-flex gap-3 align-items-center">
    <i class="fas fa-message text-primary"></i>
                <h6 class="mb-0 fw-semibold">
                  <span class="text-color">Messaging Customer's</span>
                </h6>
              </div>
       <div class="card-body p-4">
<div class="row align-items-stretch">
  <div class="col-md-6 col-sm-12 grid-col">
       <div class="form-group">
        <label class="text-color mb-2" for="message">Text Message <b>{{ charCount }}/{{ maxChars }} 
  <span v-if="charCount > 0">
    SMS {{ smsCount }}
  </span></b></label>
         <textarea :maxlength="maxChars" v-model="message" @input="handleInput" name="" placeholder="marketing or service messages..." class="form-control text-area" id="" rows="4"></textarea>
       </div>

       <div v-if="message_sending" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>
          
         <button @click="this.sendMessage()" class="btn-primary mt-3">
        <i class="fas fa-message me-2"></i>
        Send Message
      </button>
  </div>
  <div class="col-md-6 col-sm-12 grid-col">
       <div class="form-group">
        <label class="text-color mb-2" for="message">Phone Number's <i>comma (,) separated</i> </label>
         <textarea v-model="this.phonesText" placeholder="0768448525,0686255811...." class="form-control text-area" id="" rows="4"></textarea>
        
       </div>
        <label class="text-color">Contacts : <b>{{ this.phones_counts }}</b></label>
  </div>
</div>
 </div>
    </div>


        <div class="row align-items-stretch">
          <div class="col-md-12 col-sm-12 grid-col">

            <div class="product-filter-bar d-flex justify-content-between align-items-center flex-wrap gap-3 mob-mt">

  <!-- Left: Search -->
  <div class="filter-search d-flex">
    <input
      type="text"
      class="filter-search-input"
      v-model="this.search_customer"
      placeholder="Search customer..."
    />
    <button class="filter-search-btn">
      <i class="fas fa-search"></i>
    </button>
  </div>

    <div v-if="searching" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>

  <!-- Right: Filters -->
  <div class="filter-actions d-flex align-items-center gap-2 mob-grid">
     <input
      type="date"
      v-model="this.sdate" 
      class="filter-date-input"
    />
     <input
      type="date"
      v-model="this.edate" 
      class="filter-date-input"
    />
    <select v-model="this.type" class="filter-select">
      <option value="0">Created At</option>
      <option value="1">Last Order</option>
      <option value="2">Last Sold</option>
      <option value="3">Last Cancel</option>
    </select>

    <button @click="this.getclientFilter()" class="btn-primary">
      <i class="fas fa-filter me-1"></i>
      Filter
    </button>
  </div>
</div>

            <div class="card recent-orders-card mt-3">

              <!-- Card Header -->
              <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="mb-0 fw-semibold">
                  <span class="text-color">Customer's (<PriceFormat :Price="customers.length"/>)</span>
                </h6>
                <!--button class="btn-transparent text-primary text-sm">
                    <span class="fas fa-download"></span> Export
                </button-->
              </div>

              <!-- Card Body -->
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table orders-table mb-0">
                    <thead class="">
                      <tr>
                        <th class="">
                          <input class=""
              type="checkbox"
              :checked="allSelected"
              @change="toggleAll"
            />
                        </th>
                        <th class="td-wd-user">CLIENT</th>
                        <th class="td-wd">CONTACTS</th>
                        <th class="td-wd">ORDER(QNT)</th>
                        <th class="td-wd">LOCATION</th>
                        <th class="td-wd">JOIN-DATE</th>
                        <th class="td-wd">LAST-ORDER</th>
                       
                        <th class="text-end td-wd-sm">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                     
                     <tr v-for="customer in  paginatedCustomers" :key="customer.id">
                         <td class="">
<input
              type="checkbox"
              :checked="selectedPhones.includes(customer.phone)"
              @change="togglePhone(customer.phone)"
            />
                         </td>
                        <td class="text-white text-sm">
                          <UserAvatar class="text-bold" v-if="customer.avator == 'user.jpg'"
                            :fullName="customer.fulname"
                            imageUrl=""
                          />
<UserAvatar v-else
  :fullName="customer.fulname"
  :imageUrl="this.$store.state.img_url+customer.avator"
/>
                        </td>
                          <td class="text-color text-bold">
                               <PhoneFormat :Phone="customer.phone"/>
                        </td>
                        <td class="text-primary text-bold text-sm">{{ customer.total_orders }} Order's ({{ customer.total_items }})</td>
                        <td class="text-color text-sm">{{ customer.location }}</td>
                        <td class="text-green text-bold text-sm"> <DateFormat :Date_="customer.join_at"/></td>
                       <td class="text-color text-bold text-sm"> <DateFormat :Date_="customer.last_order_date"/></td>
                        <td class="text-end fw-semibold text-sm">
   <div class="order-actions">
                              <button @click="addConfirmModel(customer)" data-bs-toggle="modal" data-bs-target="#addConfirm" class="order-action-btn text-primary edit" title="Edit">
                                <i class="fas fa-eye"></i> Details
                              </button>
                             
                            </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
              </div>

            </div>


          </div>
         
        </div>
            <div class="modal fade" id="addConfirm" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Client Details</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
          <div class="modal-body custom-modal-body">
            <div class="row">
               <div class="col-sm-12 col-md-6">
                 <p class="mb-0 text-muted text-bold">Fulname :  {{client_details.fulname}}</p>
 <p class="mb-0 text-muted">Phone No :  <PhoneFormat :Phone="client_details.phone"/></p>
 <p class="mb-0 text-muted">Location :  {{client_details.location}}</p>
               </div>
                <div class="col-sm-12 col-md-6">
                  <p class="mb-0 text-muted text-bold">Order (Quantity) :  {{client_details.total_orders}} ({{ client_details.total_items }})</p>
 <p class="mb-0 text-muted">Join At :  <DateFormat :Date_="client_details.join_at"/></p>
 <p class="mb-0 text-muted">Last Order :  <DateFormat :Date_="client_details.last_order_date"/></p>
               </div>

               <div class="col-sm-12 col-md-12">
                  <div v-if="searching" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>
                <div class="table-responsive">
                  <table class="table orders-table mt-3">
                    <thead class="">
                      <tr>
                      
                        <th class="td-wd-user">ORDERID</th>
                        <th class="">SUMMARY</th>
                        <th class="td-wd">STATUS</th>
                        <th class="text-end td-wd">CREATED</th>

                      </tr>
                    </thead>
                    <tbody>
                     
                     <tr v-for="order in  orders" :key="order.id">
                         <td class="">{{ order.id }}</td>
                          <td class="text-muted text-sm">({{ order.quantity }}) {{ order.summary  }}</td>
                          <td class="text-color text-bold">  <OrderStatus :statusName="order.status_name" :statusID="order.status_id" /></td>
                       <td class="text-color text-bold text-end"> <DateFormat :Date_="order.created_at"/></td>
                      </tr>

                    </tbody>
                  </table>
                </div>
               </div>
            </div>
            <!--foradmin-->
          </div>

        </div>
      </div>
    </div>
      </div>
</template>
<script>
import axios from "axios";
import UserAvatar from "@/components/UserAvatar.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";
import OrderStatus from "@/components/OrderStatus.vue";
import PriceFormat from "@/components/PriceFormat.vue";

export default {
  components: {
    UserAvatar,
    PhoneFormat,
    DateFormat,
    OrderStatus,
    PriceFormat
  },
  data() {
    return {
       searching: false,
      add_btn: true,
      errors: "",
      data: [],
      tags:[],
      dataz:{},
      orders:[],
      customer:{},
        customers:[],
      og_customers:[],
      client_details:{},
      selectedPhones: [],
      phonesText: "",
      message: "",
      maxChars: 459,
      search_customer:"",
      currentPage: 1,
      perPage: 2,
      sdate: "",
      edate: "",
      type:0,
      phones_counts : 0,
      message_sending : false,
      user:this.$attrs.user
    };
  },
  methods: {
   
     async customerDatas() {

        this.searching = true
      var response = await axios
        .get(this.$store.state.api_url + "/customer-dataz")
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
         this.searching = false
        this.dataz = response.data.dataz;
       
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
      async getCustomers() {

        this.searching = true
      var response = await axios
        .post(this.$store.state.api_url + "/get-customers",{limit:50})
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
         this.searching = false
        this.customers = response.data.customers;
        this.og_customers = response.data.customers;
      
      } else {
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
       async getclientFilter() {

      this.searching = true

      var sdate = this.sdate
      var edate = this.edate
      var type = this.type

      var response = await axios
        .post(this.$store.state.api_url + "/get-client-filter", { sdate, edate, type })
        .catch((errors) => {
          this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
        this.searching = false
        this.customers = response.data.customers;
        this.og_customers = response.data.customers;

      } else {
        this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });

        //alert(response.data.message)
      }

    },
          async sendMessage() {

      this.message_sending = true

     var phone_list = this.phonesText
      var message = this.message

      var response = await axios
        .post(this.$store.state.api_url + "/send-message", {phone_list, message })
        .catch((errors) => {
          this.message_sending = false
          var message_ = "Network or Server Errors";
          this.$toast.error(message_, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        this.phonesText = ""
        this.message = ""
        this.message_sending = false
         var message_ = response.data.message;
        this.$toast.success(message_, { duration: 5000, dismissible: true });

      } else {
        this.message_sending = false
        var message_ = response.data.message;
        this.$toast.error(message_, { duration: 5000, dismissible: true });

        //alert(response.data.message)
      }

    },
      async addConfirmModel(client_details){

        this.client_details = client_details

        this.searching = true

       var client_id = client_details.id

         var response = await axios
        .post(this.$store.state.api_url + "/get-client-orders",{client_id})
        .catch((errors) => {
          this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
this.searching = false
        this.orders = response.data.orders;
        this.og_orders = response.data.orders;
      
      } else {
        this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
   
   togglePhone(phone) {
      const index = this.selectedPhones.indexOf(phone);

      if (index === -1) {
        this.selectedPhones.push(phone);
      } else {
        this.selectedPhones.splice(index, 1);
      }

      this.updateTextarea();
    },

    toggleAll(event) {
      if (event.target.checked) {
        const allPhones = this.customers.map(c => c.phone);
        this.selectedPhones = Array.from(
          new Set([...this.selectedPhones, ...allPhones])
        );
      } else {
        const tablePhones = this.customers.map(c => c.phone);
        this.selectedPhones = this.selectedPhones.filter(
          phone => !tablePhones.includes(phone)
        );
      }

      this.updateTextarea();
    },

    // 🔥 Important: Handle manual typing properly
    handleTextareaInput(event) {
      let value = event.target.value;

      // Normalize commas (remove double commas, extra spaces)
      value = value.replace(/,+/g, ",");
      value = value.replace(/,\s*,/g, ",");

      this.phonesText = value;

      const numbers = value
        .split(",")
        .map(n => n.trim())
        .filter(n => n !== "");

      this.selectedPhones = Array.from(new Set(numbers));
    },

    updateTextarea() {
      this.phonesText = this.selectedPhones.join(",");
    },

    handleInput(event) {
      let value = event.target.value;

      // Prevent typing beyond max
      if (value.length > this.maxChars) {
        value = value.substring(0, this.maxChars);
      }

      this.message = value;
    },
      nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  }
    
  },
  computed: {
     allSelected() {
      return (
        this.customers.length > 0 &&
        this.customers.every(c =>
          this.selectedPhones.includes(c.phone)
        )
      );
    },
    charCount() {
      return this.message.length;
    },

    smsCount() {
      if (this.charCount === 0) return 0;
      return Math.ceil(this.charCount / 153);
    },

  paginatedCustomers() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.customers.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.customers.length / this.perPage)
  },
  

},
watch: {
  search_customer(value) {

    let term = value.toLowerCase().trim()

    if(!term){
      this.customers = this.og_customers
      return
    }

    this.customers = this.og_customers.filter(customer => {

      return (
        (customer.fulname && customer.fulname.toLowerCase().includes(term)) ||
        (customer.phone && customer.phone.toLowerCase().includes(term)) ||
        (customer.id && customer.id.toString().includes(term)) ||
        (customer.location && customer.location.toLowerCase().includes(term))
       
      )

    })

  },
  phonesText(value){
    var phones = value

    phones = phones.split(',')

    this.phones_counts = phones.length
  }
},
 
  created() {
    this.$store.state.page_name = "Client's" 
    //this.dashbordMenu()
    this.getCustomers()
    this.customerDatas()
  },
};

/**
 *  {
          id:23456,
          fulname:"Richard Turnbul",
          avator:"user.jpg",
          summary:"Mafuta ya mzaituni, makatuni",
          status_name:"Operation",
          status_id:3,
          staff:"Sambokile Kindeki",
          staff_id:3,
          created_at:"12-04-2016",
          phone:"0686255811"
        },
 */
</script>
